// HUMAN integration. Detector is used in place of "White Ops/HUMAN" to help avoid detection by adversaries.
import { Detector } from '@sxmp/detector';

const config = {
  // HUMAN defined values
  clientId: '522268',
  tagId: '5222681620688193377000',
  url: 'https://s.hoplon.pandora.com/ag/522268/clear.js',

  // Pandora defined values.
  deviceId: 'pandora.com', // could be anything URL safe
  siteId: 'SXMP', // could be anything URL safe
};

export default new Detector(config);
